import { baseClasses } from '@weatherbug/common';
import { Story } from '../../components/common/utilities/newsStoryPopupTypes';
import { BreakingNewsProvider } from '../providers/breakingNewsProvider';

const { AsyncAction } = baseClasses;
export const GET_BREAKING_NEWS_STORIES = new AsyncAction('GET_BREAKING_NEWS_STORIES');
export const TOGGLE_BREAKING_NEWS = 'TOGGLE_BREAKING_NEWS';

export type GetBreakingNewsStoryActionType = {
    type: typeof GET_BREAKING_NEWS_STORIES;
    payload: Promise<Story[] | any>;
}

export type ToggleBreakingNewsActionType = {
    type: typeof TOGGLE_BREAKING_NEWS;
    payload: boolean;
}

type GetBreakingNewsParams = {
    baseUrl: string; 
    category: string;
    count?: number; 
}

export function getBreakingNewsStories({ baseUrl, category, count }: GetBreakingNewsParams): GetBreakingNewsStoryActionType {
    
    return {
        type: GET_BREAKING_NEWS_STORIES.base,
        payload: getBreakingNews({ baseUrl, category, count })
    };
}

async function getBreakingNews({ baseUrl, category, count }: GetBreakingNewsParams): Promise<Story[] | any> {
    const op = new BreakingNewsProvider(baseUrl);
    return await op.getBreakingNewsStories(category, count);
}

export function toggleBreakingNewsAction(toggleVisibility: boolean): ToggleBreakingNewsActionType {
    
    return {
        type: TOGGLE_BREAKING_NEWS,
        payload: toggleVisibility
    };
}